import { Api } from "@/core/services/api.service";
import ExportType from "@/apps/dashboard/buybackDiagnostic/core/domain/ExportType.enum";
import { ExportCsv } from "@/apps/dashboard/buybackDiagnostic/core/domain/ExportCsv";

type ExportCsvResponse = {
  id: string;
  url: string;
  entries_count: number | null;
  error: string | null;
};

export const startDiagnosticExport = async (accountId: string): Promise<ExportCsv> => {
  const response = await Api.new().post<ExportCsvResponse>(`/diagnostic-questions/exports?account_id=${accountId}`, {
    account_id: accountId,
  });
  const data = response.data;

  return new ExportCsv(data.id, ExportType.DIAGNOSTIC, data.url);
};

export const getDiagnosticCsvExport = async (exportId: string): Promise<ExportCsv> => {
  const response = await Api.new().get<ExportCsvResponse>(`/diagnostic-questions/exports/${exportId}`);
  const data = response.data;

  return new ExportCsv(data.id, ExportType.DIAGNOSTIC, data.url, data.entries_count, data.error);
};
